import React from "react";
import { useTranslation } from "react-i18next";

import styles from "../ForgotPassword.module.css";

type ResetToastProps = {
	onDismiss: () => void;
};

const ResetToast = ({ onDismiss }: ResetToastProps) => {
	const { t } = useTranslation("accountsPage");

	return (
		<div aria-live="polite" className={styles.toast} role="status">
			<span aria-hidden="true" className={styles.toastIcon}>
				<svg fill="none" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
					<path d="m7.75 12.25 2.6 2.6 5.9-6.1" />
				</svg>
			</span>
			<span className={styles.toastText}>{t("forgotPassword.toastMessage")}</span>
			<button
				aria-label={t("forgotPassword.toastDismiss")}
				className={styles.toastClose}
				onClick={onDismiss}
				type="button">
				<svg
					aria-hidden="true"
					fill="none"
					focusable="false"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg">
					<path d="m6 6 12 12M18 6 6 18" />
				</svg>
			</button>
		</div>
	);
};

export default ResetToast;
